import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SwitchBtn from "./../../components/globalComponents/Switch";
import Yearly from "../../components/Payment/Yearly";
import Monthly from "../../components/Payment/Monthly";
import Layout from "../../components/globalComponents/Layout/Layout";
import useFetch from "../../features/hooks/useFetch";
import Loader from "../../components/globalComponents/loader";
const Pricing = () => {
  const [state, setState] = useState(false);
  const { fetchData, res, loading, error } = useFetch();
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData("api/subscription/retrieve", (data) => {
      if (Array.isArray(data.data)) {
        setData(data.data);
      } else {
        console.error("Data is not an array:", data.data);
      }
    });
  }, []);

  
  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <Loader />
      </Box>
    );
  if (error) return <Box>Error: {error}</Box>;

  console.log(data,"<<<<<<<<<<<Data");
  
  return (
    <>
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <SwitchBtn
          checked={state}
          right={"Yearly"}
          left={"Monthly"}
          click={() => {
            setState(!state);
          }}
          sx={{ marginTop: "83px", marginBottom: "80px" }}
        />
        <Box>{state ? <Yearly data={data} /> : <Monthly data={data} />}</Box>
      </Box>
    </Layout>
   
    </>
  );
};

export default Pricing;
